import { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';

function fmtDate(d) { return d ? new Date(d).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' }) : '-'; }
function fmtDateTime(d) { return d ? new Date(d).toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '-'; }

const STATUS_COLORS = {
  New:      { bg: '#E3F2FD', c: '#0D47A1' },
  Preparing:{ bg: '#FFF3E0', c: '#E65100' },
  Ready:    { bg: '#E8F5E9', c: '#1B5E20' },
  Selesai:  { bg: '#F5F5F5', c: '#555' },
  Batal:    { bg: '#FFEBEE', c: '#C62828' },
};
const STATUSES = ['New', 'Preparing', 'Ready', 'Selesai', 'Batal'];

export default function OrderPOS() {
  const [orders, setOrders]     = useState([]);
  const [loading, setLoading]   = useState(true);
  const [statusFilter, setStatus] = useState('Aktif');
  const [expanded, setExpanded] = useState(null);
  const [search, setSearch]       = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    const { data } = await supabase
      .from('pos_orders')
      .select('*, customer:customers(name,wa), order_items(display_name,qty,unit_price,hpp_snapshot,note)')
      .order('created_at', { ascending: false })
      .limit(200);
    setOrders(data || []);
    setLoading(false);
  }

  async function updateStatus(id, status) {
    const extra = status === 'Selesai' ? { completed_at: new Date().toISOString() } : {};
    await supabase.from('pos_orders').update({ status, ...extra }).eq('id', id);
    load();
  }

  const filtered = orders.filter(o => {
    if (statusFilter === 'Aktif' && ['Selesai', 'Batal'].includes(o.status)) return false;
    if (statusFilter === 'Online' && o.source !== 'web') return false;
    if (!['Aktif', 'Semua', 'Online'].includes(statusFilter) && o.status !== statusFilter) return false;
    if (search) {
      const q = search.toLowerCase();
      const matchName = (o.customer_name || o.customer?.name || '').toLowerCase().includes(q);
      const matchId   = (o.id || '').toLowerCase().includes(q);
      const matchWA   = (o.customer?.wa || '').includes(q);
      if (!matchName && !matchId && !matchWA) return false;
    }
    return true;
  });

  const stats = {
    total: filtered.length,
    revenue: filtered.filter(o => o.status === 'Selesai').reduce((s, o) => s + o.total, 0),
  };

  return (
    <div style={{ padding: 'clamp(16px,4vw,28px) clamp(12px,4vw,24px) 60px' }}>
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.5rem' }}>Order POS</div>
        <div style={{ fontSize: '.82rem', color: 'var(--muted)' }}>{orders.length} order total</div>
      </div>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        {['Aktif', 'Online', 'Semua', ...STATUSES].map(s => (
          <button key={s} onClick={() => setStatus(s)} style={{ padding: '6px 14px', borderRadius: 20, border: '1px solid var(--border)', background: statusFilter === s ? '#CD5226' : 'white', color: statusFilter === s ? '#fff' : 'var(--muted)', fontSize: '.76rem', cursor: 'pointer' }}>{s}</button>
        ))}
      </div>
      <div style={{ position: 'relative', marginBottom: 16 }}>
        <span style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', fontSize: '.9rem', pointerEvents: 'none' }}>🔍</span>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Cari nama customer, nomor WA, atau ID order..."
          style={{ width: '100%', padding: '8px 12px 8px 34px', borderRadius: 8, border: '1px solid var(--border)', fontSize: '.82rem', outline: 'none', boxSizing: 'border-box', background: 'white' }}
        />
        {search && (
          <button onClick={() => setSearch('')} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)', fontSize: '.8rem' }}>✕</button>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))', gap: 10, marginBottom: 16 }}>
        {[['Order', filtered.length], ['Revenue', 'Rp ' + stats.revenue.toLocaleString('id-ID')]].map(([l,v]) => (
          <div key={l} style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', padding: '12px 14px' }}>
            <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.2rem' }}>{v}</div>
            <div style={{ fontFamily: "'DM Mono',monospace", fontSize: '.6rem', letterSpacing: '.8px', textTransform: 'uppercase', color: 'var(--muted)', marginTop: 2 }}>{l}</div>
          </div>
        ))}
      </div>

      {loading ? <div style={{ textAlign: 'center', padding: 32, color: 'var(--muted)' }}>Memuat...</div>
      : filtered.length === 0 ? <div style={{ textAlign: 'center', padding: 32, color: 'var(--muted)', fontSize: '.84rem' }}>Tidak ada order</div>
      : filtered.map(o => {
        const sc = STATUS_COLORS[o.status] || STATUS_COLORS.New;
        const isExp = expanded === o.id;
        return (
          <div key={o.id} style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', marginBottom: 8, boxShadow: 'var(--shadow)', overflow: 'hidden' }}>
            <div style={{ padding: '12px 16px', display: 'flex', gap: 12, alignItems: 'flex-start', cursor: 'pointer' }} onClick={() => setExpanded(isExp ? null : o.id)}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 3 }}>
                  <strong style={{ fontSize: '.88rem' }}>{o.customer_name || 'Tamu'}</strong>
                  <span style={{ fontFamily: "'DM Mono',monospace", fontSize: '.62rem', letterSpacing: '.5px', color: 'var(--muted)' }}>{o.type}</span>
                  <span style={{ fontFamily: "'DM Mono',monospace", fontSize: '.62rem', background: sc.bg, color: sc.c, borderRadius: 20, padding: '1px 8px' }}>{o.status}</span>
                  {o.source === 'web' && (
                    <span style={{ fontFamily: "'DM Mono',monospace", fontSize: '.6rem', background: '#E0F2FE', color: '#0369A1', borderRadius: 20, padding: '1px 8px' }}>🌐 Online</span>
                  )}
                </div>
                <div style={{ fontSize: '.76rem', color: 'var(--muted)' }}>
                  {(o.order_items || []).map(i => `${i.display_name} ×${i.qty}`).join(' · ')}
                </div>
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1rem', color: 'var(--brown)' }}>Rp {(o.total||0).toLocaleString('id-ID')}</div>
                <div style={{ fontSize: '.7rem', color: 'var(--muted)' }}>{fmtDateTime(o.created_at)}</div>
              </div>
            </div>
            {isExp && (
              <div style={{ padding: '0 16px 14px', borderTop: '1px solid var(--border)' }}>
                <div style={{ paddingTop: 12, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, fontSize: '.78rem', marginBottom: 12 }}>
                  {[['Kasir', o.staff_name || '-'], ['Pembayaran', o.payment], ['Tipe', o.type], ['ID Order', o.id?.slice(0, 12) + '...']].map(([k,v]) => (
                    <div key={k}><span style={{ color: 'var(--muted)' }}>{k}:</span> <strong>{v}</strong></div>
                  ))}
                </div>
                {o.customer?.wa && <div style={{ fontSize: '.78rem', marginBottom: 6 }}>WA: <a href={`https://wa.me/62${o.customer.wa.replace(/^0/,'')}`} target="_blank" rel="noreferrer" style={{ color: '#27AE60' }}>{o.customer.wa}</a></div>}
                {o.type === 'Delivery' && o.delivery_address && <div style={{ fontSize: '.78rem', marginBottom: 6 }}><span style={{ color: 'var(--muted)' }}>Alamat:</span> {o.delivery_address}</div>}
                {o.notes && <div style={{ fontSize: '.78rem', marginBottom: 10 }}><span style={{ color: 'var(--muted)' }}>Catatan:</span> {o.notes}</div>}
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {STATUSES.filter(s => s !== o.status).map(s => (
                    <button key={s} onClick={() => updateStatus(o.id, s)} style={{ padding: '4px 10px', borderRadius: 6, background: STATUS_COLORS[s]?.bg || '#F5F5F5', color: STATUS_COLORS[s]?.c || '#555', border: '1px solid rgba(0,0,0,.08)', fontSize: '.72rem', cursor: 'pointer' }}>
                      → {s}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
